import { render, staticRenderFns } from "./resource-status-view.vue?vue&type=template&id=ecb2b48c&scoped=true"
import script from "./resource-status-view.vue?vue&type=script&lang=js"
export * from "./resource-status-view.vue?vue&type=script&lang=js"
import style0 from "./resource-status-view.vue?vue&type=style&index=0&id=ecb2b48c&prod&lang=scss&scoped=true"
import style1 from "./resource-status-view.vue?vue&type=style&index=1&id=ecb2b48c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb2b48c",
  null
  
)

export default component.exports